import React from "react"
import RPMCriticalTimePassedPatientScreen from "../components/RPMCriticalInitialScreen/RPMCriticalTimePassedPatientScreen"

const RpmCriticalTimePassedInitialScreen = () => <RPMCriticalTimePassedPatientScreen />

export default RpmCriticalTimePassedInitialScreen
